import React from 'react'
import { useConfiguratorContext } from '@augmatica/iframe-interface-react'

import { getDmPropsForChosenValues } from '../../helpers/getDmPropsForChosenValues'
import { getPropsForUpdate } from '../../helpers/getPropsForUpdate'
import { isLfcItem as checkIsLfcItem } from '../../helpers/isLfcItem'
import { postLfcConfigresult } from '../../store/requests/apiRequests/postLfcConfigresult'
import { handleSelectedItem } from '../../store/selectedItem/selectedItemSlice'
import { setIsEditItemPanelActive } from '../../store/ui/uiSlice'
import Lfc from '../Lfc/Lfc'
import * as Styled from './styles'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { getItemTypeForDmItem } from '../../helpers/getItemTypeForDynaMakerItem'

const EditItemPanel: React.FC = () => {
  const dispatch = useAppDispatch()

  const configurator = useConfiguratorContext()

  const { content } = useAppSelector((state) => state.init)
  const { erpItems, lfcItems } = useAppSelector((state) => state.items)
  const { apiConfigs } = useAppSelector((state) => state.requests)
  const { selectedItem } = useAppSelector((state) => state.selectedItem)
  const { isEditItemPanelActive } = useAppSelector((state) => state.ui)

  if (selectedItem.item === 'assembly') return null // Not applicable

  const editItemTitle = content.items[getItemTypeForDmItem(selectedItem.item) ?? '']?.editItem.title

  const isLfcItem = checkIsLfcItem(selectedItem as any) // TODO

  if (!isLfcItem) return null

  const lfcItem = isLfcItem
    ? lfcItems.find((lfcItem) => lfcItem.configuratorContextId === selectedItem.props?.configData.contextId)
    : null

  return (
    <Styled.EditItemPanel isEditItemPanelActive={isEditItemPanelActive}>
      <div className="edit-item-header">
        {editItemTitle}
        <button
          className="button-done"
          onClick={() => {
            dispatch(setIsEditItemPanelActive(false))
            configurator.cameraToPrevious()
          }}
        >
          Klar
        </button>
      </div>
      <Lfc
        lfcItem={lfcItem!} // TODO can lfcItem be undefined?
        chosenValues={selectedItem.props?.configData.chosenValues}
        configResult={selectedItem.props?.configData.configResult}
        onChange={(newChosenValues) => {
          // Note: No thunk is dispatched here, response data is stored in DynaMaker instead of Redux store
          postLfcConfigresult({
            apiConfigs,
            data: {
              contextId: selectedItem.props?.configData.contextId,
              chosenValues: newChosenValues,
              pricingInfo: erpItems.find((erpItem) => erpItem.Sku === selectedItem.erpItemNumber)?.PricingInfo,
            },
            onSuccess: (response) => {
              const configResult = response.data
              const _lastFetched = Date.now()

              const propsForNewChosenValues = getDmPropsForChosenValues(newChosenValues, lfcItem?.dimensions)

              const updatedProps = {
                ...selectedItem.props,
                ...propsForNewChosenValues,
                configData: {
                  ...selectedItem.props?.configData,
                  _lastFetched,
                  chosenValues: newChosenValues,
                  configResult,
                },
              }

              dispatch(
                handleSelectedItem({
                  erpItemNumber: selectedItem.erpItemNumber,
                  id: selectedItem.id,
                  item: selectedItem.item,
                  props: updatedProps,
                })
              )

              if (selectedItem.props) {
                const propsForUpdate = getPropsForUpdate(selectedItem.props as any, updatedProps as any) // TODO
                configurator.updateItem(selectedItem.item, selectedItem.id, propsForUpdate as any) // TODO
              }
            },
          })
        }}
      />
    </Styled.EditItemPanel>
  )
}

export default EditItemPanel
